import React from "react";
import Navbar from "../Components/Navbar/Navbar";

const Team = () => {
  return (
    <div>
      <Navbar />
      <div>Team</div>
    </div>
  );
};

export default Team;
